ApplyCancelButtons = require 'components/common/apply_cancel_buttons'
ConnectStore = require 'components/enhancers/connect_store'
LaserStore = require 'stores/laser_store'
Modal = require 'components/common/modal'
LaserActions = require 'actions/laser_actions'
QuestionsStore = require 'stores/questions_store'
QuestionGroupsStore = require 'stores/question_groups_store'
QuestionsStatusesStore = require 'stores/questions_statuses_store'
QuestionsSelector = require 'components/common/questions_selector'
QuestionWithCheckbox = require 'components/common/question_with_checkbox'
Translation = require 'components/mixins/translation'
{ useI18n, useCoffeeCallback, useCoffeeMemo } = require 'lib/react_utils'

storeConnector =
  LaserStore: (Store) ->
    isCreating: Store.isCreatingQuestionInLaser()
    isOpen: Store.isCreatingQuestionDialogOpen()
    currentQuestionId: Store.getCreateQuestionInLaserMainId()
    selectedQuestions: Store.getSelectedQuestions()

  QuestionsStore: (Store) ->
    questions: Store.getQuestions()

  QuestionsStatusesStore: (Store) ->
    questionsStatuses: Store.getQuestionsStatuses()

  QuestionGroupsStore: (Store) ->
    questionGroups: Store.getQuestionGroups()

CreateQuestionInLaserDialog = ({
  currentQuestionId
  isCreating
  isOpen
  questions
  questionGroups
  questionsStatuses
  selectedQuestions
}) ->

  i18n = useI18n "laser:create_question_dialog"

  createQuestions = useCoffeeCallback [selectedQuestions, currentQuestionId], ->
    LaserActions.createQuestionsInLaser(selectedQuestions.concat(currentQuestionId))

  currentQuestion = useCoffeeMemo [questions, currentQuestionId], ->
    questions.find(
      (q) -> q.get('_id') is currentQuestionId,
      null,
      Immutable.Map()
    )

  questionsList = useCoffeeMemo [questions, currentQuestionId], ->
    questions.filter (q) ->
      q.get('_id') isnt currentQuestionId and
      questionsStatuses.getIn([q.get('_id'), 'laserStatus'], Immutable.Map()).isEmpty()

  <Modal
    className="laser-create-question-dialog"
    isOpen={isOpen}
    modalSize="medium"
    title={i18n 'title'}
  >
    <div className="questions-selector">
      <div className="questions-selector__questions">
        <div className="questions-list">
          <QuestionWithCheckbox
            checked
            question={currentQuestion}
            readonly
          />
        </div>
      </div>
    </div>
    <div className="laser-create-question-dialog__description">
      {i18n 'questions_with_the_same_status'}
    </div>
    <div className="mb-20">
      <QuestionsSelector
        questionGroups={questionGroups}
        questions={questionsList}
        selectedQuestions={selectedQuestions}
        updateSelected={LaserActions.setSelectedQuestions}
      />
    </div>
    <ApplyCancelButtons
      applying={isCreating}
      onApply={createQuestions}
      onCancel={LaserActions.closeCreateQuestionInLaserDialog}
    />
  </Modal>

module.exports = ConnectStore CreateQuestionInLaserDialog, [
  LaserStore,
  QuestionsStore,
  QuestionGroupsStore
  QuestionsStatusesStore
  ], storeConnector
